import React, {useMemo, useState} from 'react';

import cs from 'classnames';
import moment from 'moment-tz';

interface Props {
  dueDate: string;
  onChange: (dueDate: string) => unknown;
  tz: string;
  userLanguage: string;
}

export function DueTimeInputField({
  dueDate,
  onChange,
  tz,
  userLanguage,
}: Props): JSX.Element {
  const lastValidTime = useMemo(
    () => moment.tz(dueDate, tz).format('h:mma'),
    [dueDate, tz]
  );

  const [value, setValue] = useState(lastValidTime);

  const [isInvalid, setIsInvalid] = useState(false);

  function handleChange(inputValue: string) {
    setValue(inputValue);

    const time = moment(
      inputValue.trim(),
      ['ha', 'h a', 'h:ma', 'h:m a', 'hma', 'hm a', 'LT', 'H:m'],
      userLanguage,
      true
    );

    if (!time.isValid()) {
      setIsInvalid(true);
    } else {
      setIsInvalid(false);

      onChange(
        moment
          .tz(dueDate, tz)
          .hour(time.hour())
          .minute(time.minute())
          .toISOString()
      );
    }
  }

  return (
    <input
      type="text"
      onChange={(e) => handleChange(e.target.value)}
      value={value}
      className={cs('form-control', {'is-invalid': isInvalid})}
      placeholder={lastValidTime}
      onBlur={() => {
        if (isInvalid) {
          handleChange(lastValidTime);
        }
      }}
    />
  );
}
